<template>
	<div class="flex flex-col gap-3 px-6 py-4 md:pt-10 md:pb-6">
		<div class="flex flex-col gap-3">
			<div class="flex flex-col text-center md:min-h-[68px]">
				<p class="text-xs font-medium text-won-secondary">
					Basic
				</p>
				<p class="text-3xl leading-9 font-semibold tracking-tight text-gray-900">
					Free
				</p>
			</div>
			<div class="flex flex-col gap-2">
				<div
					v-if="ctaLabel"
					class="md:min-h-[52px]"
				>
					<button
						type="button"
						:disabled="ctaDisabled"
						class="flex h-9 w-full items-center justify-center rounded-md bg-gray-100 px-3 text-sm font-medium text-gray-900 hover:bg-gray-200 disabled:pointer-events-none disabled:opacity-50"
						@click="emit('cta')"
					>
						{{ ctaLabel }}
					</button>
				</div>
				<PlanDetailsToggle
					v-if="collapsible"
					v-model="detailsOpen"
				/>
			</div>
		</div>
		<div :class="[collapsible && !detailsOpen ? 'hidden md:flex' : 'flex', 'flex-col gap-3']">
			<hr class="border-gray-200" />
			<PlanFeatureGroups :groups="BASIC_PLAN_GROUPS" />
		</div>
	</div>
</template>

<script setup>
import { ref } from 'vue';

import PlanDetailsToggle from './plan-details-toggle.vue';
import PlanFeatureGroups from './plan-feature-groups.vue';
import { BASIC_PLAN_GROUPS } from '../../../constants/pricing-plans';

const props = defineProps({
	// "Current Plan", "Stay On Free" or "Upgrade later"; null when the user already pays.
	ctaLabel: {
		type: String,
		default: null,
	},
	ctaDisabled: {
		type: Boolean,
		default: false,
	},
	// On mobile the feature list sits behind "Plan Details" unless this is false.
	collapsible: {
		type: Boolean,
		default: true,
	},
});

const emit = defineEmits(['cta']);

const detailsOpen = ref(!props.collapsible);
</script>
